import { render, staticRenderFns } from "./myFavarArticle.vue?vue&type=template&id=5a260809&scoped=true"
import script from "./myFavarArticle.vue?vue&type=script&lang=js"
export * from "./myFavarArticle.vue?vue&type=script&lang=js"
import style0 from "./myFavarArticle.vue?vue&type=style&index=0&id=5a260809&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a260809",
  null
  
)

export default component.exports